import { types } from "mobx-state-tree";
import { TaintModel, UnmanagedPoolModel } from "./common";
import { AutoscalerModel } from "./autoscaler";
import { PreInstallScriptProperty } from "./preInstallScript";

const OblivusProviderNodePoolModel = types.model("LambdaLabs Provider Node Pool", {
  name: types.string,
  labels: types.frozen(),
  taints: types.array(TaintModel),
  minSize: types.number,
  maxSize: types.number,
  flavor: types.string,
});

export const OblivusProviderModel = types.model("Oblivus Provider", {
  datacenter: types.optional(types.string, ""), // 'CHI1', 'NYC1', 'LAS1'
  tokenSecretLink: types.string,
  nodePools: types.array(OblivusProviderNodePoolModel),
  sshKeys: types.array(types.string),
  unmanagedNodePools: types.array(UnmanagedPoolModel),
  autoscaler: types.optional(AutoscalerModel, () => AutoscalerModel.create()),
  preInstallScript: PreInstallScriptProperty,
});
